import * as dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

dayjs.extend(duration)

export const timeToDuration = time => {
  if (!time || typeof time !== 'string') {
    return false
  }

  time = time.replace('PT', '')
  const data = dayjs.duration(time)
  const response = {
    hours: data.hours(),
    minutes: data.minutes(),
    seconds: data.seconds()
  }

  // if 0 everywhere, return false
  if (!response.hours && !response.minutes && !response.seconds) {
    return false
  }

  return response
}

export const secondsToDuration = seconds => {
  if (!seconds) {
    return false
  }

  const data = dayjs.duration(seconds, 'seconds')
  const response = {
    hours: data.hours(),
    minutes: data.minutes(),
    seconds: data.seconds()
  }

  // if 0 everywhere, return false
  if (!response.hours && !response.minutes && !response.seconds) {
    return false
  }

  return response
}

export const minutesToDuration = minutes => {
  if (!minutes) {
    return false
  }

  const data = dayjs.duration(minutes, 'minutes')
  const response = {
    hours: data.hours(),
    minutes: data.minutes(),
    seconds: data.seconds()
  }

  // if 0 everywhere, return false
  if (!response.hours && !response.minutes && !response.seconds) {
    return false
  }

  return response
}

export const durationToString = duration => {
  if (!duration) {
    return false
  }

  return `
    ${duration.hours ? `${duration.hours} h` : ''}
    ${duration.minutes ? `${duration.minutes} min` : ''}
    ${duration.seconds ? `${duration.seconds} sec` : ''}
  `.trim()
}

export const durationToISO8601 = duration => {
  return `PT${duration.hours ? `${duration.hours}H` : ''}${duration.minutes ? `${duration.minutes}M` : ''}${duration.seconds ? `${duration.seconds}S` : ''}`
}
